/**
 * Higher-Order Component (HOC) to inject React Router v6 hooks (`useParams`, `useLocation`, `useNavigate`)
 * into class components, preserving the behavior of `react-router-dom` v5's `withRouter()`.
 * This allows class components to access route parameters, navigation, and location properties.
 */
import React from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";

export function withRouter(Component) {
  return function (props) {
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    return <Component {...props} params={params} location={location} navigate={navigate} />;
  };
}
